// Built by: https://github.com/mbasso/react-https-redirect
// Modified to include 'dev.defisolutions.com'

import PropTypes from 'prop-types';

const isLocalHost = hostname => !!(
  hostname === 'localhost' ||
  hostname === '[::1]' ||
  hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/) ||
  hostname === 'dev.defisolutions.com'
);

const HttpsRedirect = ({ children }) => {
  
  if (
    typeof window !== 'undefined' &&
    window.location &&
    window.location.protocol === 'http:' &&
    !isLocalHost(window.location.hostname)
  ) {
    window.location.href = window.location.href.replace(
      /^http(?!s)/,
      'https'
    );
    return null;
  }

  return children;
};

HttpsRedirect.propTypes = {
  children: PropTypes.node,
};

export default HttpsRedirect;